/**
 * @group Action
 * @summary <blockquote>Standard error messages for server action operations.</blockquote>
 */
export const ACTION_ERROR_MESSAGES = {
  FETCH_FAILED: 'Failed to retrieve data',
  CREATE_FAILED: 'Failed to create item',
  UPDATE_FAILED: 'Failed to update item',
  DELETE_FAILED: 'Failed to delete item',
  SAVE_FAILED: 'Failed to save item',
  PERMISSION_DENIED: 'Permission denied',
  INVALID_DATA: 'Invalid data provided',
  NOT_FOUND: 'Item not found',
  // Patient-specific error messages
  CONSULTATION_START_FAILED: 'Failed to start consultation',
  CONSULTATION_END_FAILED: 'Failed to end consultation',
  CONSULTATION_CANCEL_FAILED: 'Failed to cancel consultation',
  PROFILE_VALIDATION_FAILED: 'Failed to validate patient profile',
  PROFILE_UPSERT_FAILED: 'Failed to create or update patient profile',
  PAYMENT_METHOD_SET_DEFAULT_FAILED: 'Failed to set default payment method',
  PAYMENT_METHOD_VALIDATION_FAILED: 'Failed to validate payment method',
  PROFILE_ALREADY_EXISTS: 'Patient profile already exists for this user',
  NO_DEFAULT_PAYMENT_METHOD: 'No default payment method found',
  INVALID_CONSULTATION_STATUS: 'Invalid consultation status transition',
} as const; 